namespace Matrix.Dashboards {
    export interface AggregateField {
        Field?: string;
        Type?: AggregateType;
    }
}
